<template>
  <v-tabs
    :value="activeTab"
    show-arrows
    :centered="centerTabs"
    :right="alignTabsRight"
    :key="key"
    :style="tabsStyling"
  >
    <v-tabs-slider :color="tabsSliderColor"/>
    <v-tab
      v-for="(tab, index) in tabs"
      :key="tab.label"
      :style="[tabsLabelsStyling, {color: activeTab === index ? tabsLabelColor : '#767676'}]"
      :disabled="tab.disabled ? tab.disabled : false"
      @change="$emit('startTabChange', index)"
    >
      {{ translateLabels ? $tc(getTranslationKey(tab.label), 2) : tab.label }}
    </v-tab>
  </v-tabs>
</template>

<script>
import { bus } from "@/main.js";
export default {
  name: "Tabs",

  props: {
    tabs: {
      type: Array,
      required: true,
    },

    activeTab: {
      type: Number,
      required: true,
    },

    translateLabels: {
      type: Boolean,
      default: false,
    },

    tabsStyling: {
      type: Object,
      default: () => { return {
        'height': '57px',
        'background-color': 'transparent'
      }}
    },

    tabsSliderColor: {
      type: String,
      default: "#29BDF0",
    },

    tabsLabelColor: {
      type: String,
      default: "#29BDF0",
    },

    tabsLabelsStyling: {
      type: Object,
      default: () => { return {
        'text-transform': 'none',
        'font-size': '12px',
        'letter-spacing': '0',
      }},
    },

    centerTabs: {
      type: Boolean,
      default: true,
    },

    alignTabsRight: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      key: 0,
    }
  },
  mounted(){
    bus.$on("re-render", () => {
        this.key++;
    });
  },

  watch: {
    tabs: {
      handler() {
        this.resetTabs();
      },
      deep: true,
    },
  },

  destroyed() {
    bus.$off("re-render");
  },
  methods:{
    getTranslationKey(label) {
      return this.$store.getters.getLayerTranslationKey(label);
    },
    resetTabs() {
      this.$nextTick(() => {
        this.key++;
      });
    },
  },
}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/newComponents/_Atoms/Tabs.vue